import React from 'react';

const IconFigma = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48px" height="48px">
    <path fill="#0ACF83" d="M18 6a6 6 0 016 6v6h-6a6 6 0 110-12z" />
    <path fill="#A259FF" d="M18 18h6a6 6 0 106-6 6 6 0 00-6-6h-6v12z" />
    <path fill="#F24E1E" d="M18 30h6a6 6 0 106-6 6 6 0 00-6-6h-6v12z" />
    <path fill="#FF7262" d="M12 18a6 6 0 016-6v12a6 6 0 01-6-6z" />
    <path fill="#1ABCFE" d="M18 30a6 6 0 016 6 6 6 0 01-6 6 6 6 0 01-6-6 6 6 0 016-6z" />
  </svg>
);

export default IconFigma;
